import { useLocation } from 'react-router-dom';
import ServiceLandingPage from './ServiceLandingPage';
import IndustryPage from './IndustryPage';

// All valid service and industry slugs
const servicePages = [
    'gmb-optimization-services',
    'geo-seo-services', 
    'ai-search-optimization',
    'seo-services',
    'programmatic-seo',
];

const industryPages = [
    'healthcare-seo',
    'clinic-seo',
    'travel-seo',
    'visa-agency-seo',
    'local-business-seo',
];

export default function DynamicPage() {
    const location = useLocation();
    const slug = location.pathname.slice(1); // Remove leading slash

    if (servicePages.includes(slug)) {
        return <ServiceLandingPage />;
    }
    
    if (industryPages.includes(slug)) {
        return <IndustryPage />;
    }

    // 404 fallback
    return (
        <div className="min-h-[60vh] flex items-center justify-center">
            <div className="text-center">
                <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
                <p className="text-xl text-muted-foreground mb-8">Page not found</p>
                <a 
                    href="/" 
                    className="inline-flex items-center px-6 py-3 rounded-full bg-primary text-primary-foreground font-medium"
                >
                    Go Home
                </a>
            </div>
        </div>
    );
}
